import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';

const TESTING_STEP_KEY = 'testing-step'

export interface State {
  step: number;
  stopDemo: boolean;
}

const defaultState: State = {
  step: 0,
  stopDemo: false // Флаг для отображения окна завершения демонстрации
};

const getters = {
  step: (state: State) => state.step,
  stopDemo: (state: State) => state.stopDemo,
};

const mutations: MutationTree<State> = {

  step(state: State, step: number) {
    state.step = step;
    sessionStorage.setItem(TESTING_STEP_KEY, String(state.step))
  },

  nextStep(state: State) {
    state.step += 1;
    sessionStorage.setItem(TESTING_STEP_KEY, String(state.step))
  },

  stopDemo(state: State) {
    state.stopDemo = true
  },
  cancelStopDemo(state: State) {
    state.stopDemo = false
  },
  stop(state: State) {
    state.step = 0
    state.stopDemo = false
    sessionStorage.setItem(TESTING_STEP_KEY, '0')
  }

};

const actions: ActionTree<State, RootState> = {
  step(ctx, step: number) {
    ctx.commit('step', step)
  },
  nextStep(ctx) {
    ctx.commit('nextStep')
  },
  stopDemo(ctx) {
    ctx.commit('stopDemo');
  },
  cancelStopDemo(ctx) {
    ctx.commit('cancelStopDemo');
  },
  stop(ctx) {
    ctx.commit('stop');
  },
  load(ctx) {
    let step = Number(sessionStorage.getItem(TESTING_STEP_KEY))
    if(step < 0 || step > 7) step = 0;
    ctx.commit('step', step)
  }
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
